import {ObjectState} from '../ObjectState';

export enum ObjectContextActionType {
  LOADING,
  GET_OBJECT,
  ERROR
}

export type ObjectContextAction = {
  type: ObjectContextActionType;
  payload: any;
};

export const ObjectContextReducer = (state: ObjectState, action: ObjectContextAction) => {
  switch (action.type) {
    case ObjectContextActionType.LOADING:
      return {
        ...state,
        details: undefined,
        loading: true,
        errors: []
      };
    case ObjectContextActionType.GET_OBJECT:
      return {
        ...state,
        details: action.payload.details,
        loading: false,
        errors: action.payload.errors
      };
    case ObjectContextActionType.ERROR:
      return {
        ...state,
        details: undefined,
        loading: false,
        errors: action.payload.errors
      };
    default:
      return state;
  }
};
